exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-73ea010c] {\n  border: 1px solid #d7d8da;\n}\n.table th[data-v-73ea010c], .table td[data-v-73ea010c] {\n  font-size: 11px;\n}", ""]);

// exports
